import { render, staticRenderFns } from "./invoices_detail_customer_view.vue?vue&type=template&id=0c575e58&scoped=true&"
import script from "./invoices_detail_customer_view.vue?vue&type=script&lang=js&"
export * from "./invoices_detail_customer_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c575e58",
  null
  
)

export default component.exports